import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { usePolicy } from 'dashboard/composables/usePolicy';

// Acesso às CHAMADAS por provedor — SEPARADOS. Cada um exige:
//   • o módulo da empresa (`wavoip` / `astracall`) habilitado (Super Admin), E
//   • poder receber — admin/agente padrão sempre podem; funções personalizadas
//     só com a permissão específica.
// Espelha o padrão `moduleAllowed` do Sidebar (feature_modules + checkPermissions).
export function useWhatsappCallAccess() {
  const { currentAccount } = useAccount();
  const { checkPermissions } = usePolicy();

  const moduleOn = key => currentAccount.value?.feature_modules?.[key] === true;

  const canReceiveWavoipCalls = computed(
    () =>
      moduleOn('wavoip') &&
      checkPermissions(['administrator', 'agent', 'wavoip_calls_receive'])
  );

  const canReceiveAstracallCalls = computed(
    () =>
      moduleOn('astracall') &&
      checkPermissions(['administrator', 'agent', 'astracall_calls_receive'])
  );

  // Ligação WhatsApp OFICIAL via 360Dialog (Calling API). O canal já é gateado por
  // voice_enabled + CHANNEL_VOICE; aqui aplicamos o controle extra de módulo/permissão.
  const canReceiveWhatsapp360Calls = computed(
    () =>
      moduleOn('whatsapp_360_calls') &&
      checkPermissions(['administrator', 'agent', 'whatsapp_360_calls_receive'])
  );

  return {
    canReceiveWavoipCalls,
    canReceiveAstracallCalls,
    canReceiveWhatsapp360Calls,
  };
}
